import { z } from 'zod';

const AddSymbolToWatchlist = z.object({
  watchlistId: z.string(),
  isinCode: z.string().nullable(),
});

const RemoveSymbolFromWatchlist = z.object({
  watchlistId: z.string(),
  isin: z.string().nullable(),
});

const AddWatchlist = z.object({
  id: z.number(),
  title: z.string().nullable(),
  note: z.string().nullable(),
});

const AddWatchlistQuery = z.object({
  result: AddWatchlist.nullable(),
});

const Watchlist = z.object({
  id: z.string(),
  title: z.string().nullable(),
  note: z.string().nullable(),
  type: z.number(),
});

const WatchlistQuery = z.object({
  totalCount: z.number(),
  items: Watchlist.array().nullable(),
});

const WatchlistItem = z.object({
  instrumentId: z.number().optional(),
  instrumentTitle: z.string().nullable(),
  instrumentName: z.string().nullable(),
  instrumentTypeCode: z.number(),
  instrumentGroupId: z.string().nullable(),
  lastTradePrice: z.number(),
  referencePriceVariationPercentage: z.number(),
  referencePriceVariation: z.number().nullable().optional(),
  instrumentStateCode: z.string().nullable(),
  instrumentTradingState: z.number(),
  isin: z.string().nullable(),
  instrumentIsin: z.string().nullable().optional(),
  instrumentStateTitle: z.string().nullable(),
  theoricalOpeningPrice: z.number(),
  topVariation: z.number().optional(),
  topVariationPercentage: z.number(),
  totalTradedQuantityAtOpening: z.number(),
  sectorCode: z.string().nullable(),
  subSectorCode: z.string().nullable(),
  exchangeCode: z.string().nullable(),
  closingPrice: z.number(),
  closingPriceVariationPercentage: z.number(),
  instrumentAssetClassName: z.string().nullable(),
});

const WatchlistItemsQuery = z.object({
  totalCount: z.number(),
  items: WatchlistItem.array().nullable(),
});

const WatchlistOverview = z.object({
  id: z.string(),
  title: z.string().nullable(),
  isins: z.array(z.string()).nullable(),
});

const WatchlistOverviewQuery = z.array(WatchlistOverview);

type WatchlistQuery = z.infer<typeof WatchlistQuery>;
type WatchlistItemsQuery = z.infer<typeof WatchlistItemsQuery>;
type WatchlistItem = z.infer<typeof WatchlistItem>;
type Watchlist = z.infer<typeof Watchlist>;
type AddWatchlist = z.infer<typeof AddWatchlist>;
type AddWatchlistQuery = z.infer<typeof AddWatchlistQuery>;
type WatchlistOverviewQuery = z.infer<typeof WatchlistOverviewQuery>;
type AddSymbolToWatchlist = z.infer<typeof AddSymbolToWatchlist>;
type RemoveSymbolFromWatchlist = z.infer<typeof RemoveSymbolFromWatchlist>;

export {
  WatchlistQuery,
  WatchlistItemsQuery,
  WatchlistItem,
  Watchlist,
  AddWatchlist,
  AddWatchlistQuery,
  WatchlistOverviewQuery,
  AddSymbolToWatchlist,
  RemoveSymbolFromWatchlist,
};
